var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEmpty)?_c('NoRecord'):_c('Chart',{attrs:{"options":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }